/// Triggers an event on the element
///
/// @param name   The name of the event
/// @param data   Custom data to send with the event
var triggerEvent = function triggerEvent(name, data) {
  var options = {
    cancelable: true
  };
  var event;

  if (data !== undefined) {
    options.detail = data;
    event = new CustomEvent(name, options);
  } else {
    event = new Event(name, options);
  }

  return this.dispatchEvent(event);
};

window.document.triggerEvent = triggerEvent;
HTMLElement.prototype.triggerEvent = triggerEvent; /// Adds an event listener for an event on the document.
/// The listener will be bound to the current element.
///
/// @param name       The name of the event
/// @param listener   The function to run when the event is triggered
/// @param options    Event listener options

HTMLElement.prototype.addDocumentBoundEventListener = function (name, listener, options) {
  this._documentBoundEvents = this._documentBoundEvents || {};
  var boundListener = listener.bind(this);
  this._documentBoundEvents[name] = boundListener;
  document.addEventListener(name, boundListener, options);
}; /// Removes an event listener for an event on the document.
///
/// @param name       The name of the event


HTMLElement.prototype.removeDocumentBoundEventListener = function (name) {
  if (this._documentBoundEvents && this._documentBoundEvents[name]) {
    document.removeEventListener(name, this._documentBoundEvents[name]);
    delete this._documentBoundEvents[name];
  }
}; /// Adds an event listener for an event on the window.
/// The listener will be bound to the current element.
///
/// @param name       The name of the event
/// @param listener   The function to run when the event is triggered
/// @param options    Event listener options


HTMLElement.prototype.addWindowBoundEventListener = function (name, listener, options) {
  this._windowBoundEvents = this._windowBoundEvents || {};
  var boundListener = listener.bind(this);
  this._windowBoundEvents[name] = boundListener;
  window.addEventListener(name, boundListener, options);
}; /// Removes an event listener for an event on the window.
///
/// @param name       The name of the event


HTMLElement.prototype.removeWindowBoundEventListener = function (name) {
  if (this._windowBoundEvents && this._windowBoundEvents[name]) {
    window.removeEventListener(name, this._windowBoundEvents[name]);
    delete this._windowBoundEvents[name];
  }
}; /// Adds an event listener for children.
/// This is triggered when the listened event occurs on a child, then bubbles up to the element.
///
/// @param name       The name of the event
/// @param selector   The child selector
/// @param listener   The function to run when the event is triggered
/// @param options    Event listener options


var addEventSelectorListener = function addEventSelectorListener(name, selector, listener, options) {
  this.addEventListener(name, function (event) {
    var selectorElement = event.target.closest(selector);

    if (selectorElement !== null) {
      event.selectedTarget = selectorElement;
      listener(event);
    }
  }, options);
};

window.document.addEventSelectorListener = addEventSelectorListener;
HTMLElement.prototype.addEventSelectorListener = addEventSelectorListener;